module.exports = __webpack_public_path__ + "static/media/smooth.4c3d6f5f.svg";